import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ToastFile from "../../../utils/ToastFile";
import { updateTaskLog } from "../../../api/TaskApi";
import moment from "moment";
import ButtonLoader from "../../../components/ButtonLoader";
import { addLocation } from "../../../api/locationApi";
import { getCurrentLocation } from "../../../utils/getLocation";
import { getEmployeeDetails } from "../../../api/EmployeeApi";
import { ALLOWED_RADIUS_KM, calculateDistanceInKm, formatHours, OFFICE_LOCATION } from "../../../utils/utility";

const UpdateMyTask = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isActionEdit, setIsActionEdit] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [isLoading, setIsloading] = useState(false);
  const [isLocationEnable, setIsLocationEnable] = useState(false);
  const [isFixedPay, setIsFixedPay] = useState(false);
  const [isLimited7_5Hours, setIsLimited7_5Hours] = useState(false);

  useEffect(() => {
    if (state?.mode === "Edit") {
      setIsActionEdit(true);
      reset(state?.taskLog);
    } else {
      setIsActionEdit(false);
      reset(state?.taskLog);
    }
    getEmployee();
  }, []);

  const getEmployee = async () => {
    await getEmployeeDetails(user.id).then((employeeRes) => {
      const employee = employeeRes?.data?.data;
      if (employee?.settings) {
        try {
          const settings =
            typeof employee.settings === "string"
              ? JSON.parse(employee.settings)
              : employee.settings;
          setIsLocationEnable(Boolean(settings?.LocationTracking));
          setIsFixedPay(
            Boolean(
              settings?.FixedPay ||
                settings?.fixedPay ||
                settings?.["Fixed Pay"],
            ),
          );
          setIsLimited7_5Hours(Boolean(settings?.Limited7_5Hours));
        } catch (e) {
          console.error("Error parsing settings:", e);
        }
      }
    });
  };

  const navigationToBack = () => {
    if (state?.from === "task") {
      navigate("/mytask");
    } else {
      navigate("/taskhistory");
    }
  };

  const onSubmit = async (data) => {
    if (isLimited7_5Hours && data.claimHours) {
      // const [hours, minutes = 0] = String(data.claimHours)
      //   .split(":")
      //   .map(Number);
      //const actualMinutes = hours * 60 + minutes;

      if (data.claimHours > 7.5) {
        ToastFile("You are not allowed to enter more than 7.5 hours.", "error");
        return;
      }
    }

    let payload = {
      ...data,
      date: data.date ? moment(new Date(data.date)).format("YYYY-MM-DD") : null,
      startTime: data.startTime
        ? new Date(`1970-01-01T${data.startTime}:00`)
        : null,
      endTime: data.endTime ? new Date(`1970-01-01T${data.endTime}:00`) : null,
      employee: user.id,
      tenant_id: state?.taskLog.tenant_id,
      status: state?.taskLog.status,
      createdBy: state?.taskLog.createdBy,
      createdAt: state?.taskLog.createdAt,
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
      isApproved: "",
    };
    if (isActionEdit) {
      if (isLocationEnable) {
        try {
          const position = await getCurrentLocation();
          const { latitude, longitude } = position.coords;

          // // Calculate distance from office
          // const distance = calculateDistanceInKm(
          //   latitude,
          //   longitude,
          //   OFFICE_LOCATION.latitude,
          //   OFFICE_LOCATION.longitude
          // );
          
          // console.log("Distance from office:", distance, "KM");
          
          // // Check 1 KM restriction
          // if (distance > ALLOWED_RADIUS_KM) {
          //   ToastFile("You don't allowed to start task at this location. Please reach office and try again.",
          //             "error");
            
          //   return;
          // }

          setIsloading(true);
          await updateTaskLog(state?.taskLog?._id, payload)
            .then(async (res) => {
              setIsloading(false);
              if (res.status === 200) {
                ToastFile("Task updated successfully", "updated");
                reset();

                const body = {
                  taskLog_id: data.taskLog_id,
                  employee: user.id,
                  events: "end",
                  latitude,
                  longitude,
                  createdAt: new Date(),
                };

                const response = await addLocation(body);
                if (response.status === 200) {
                  console.log("Location added");
                }

                navigationToBack();
              } else {
                ToastFile("Failed to update task", "error");
              }
            })
            .catch((err) => {
              setIsloading(false);
              console.error("Error updating task:", err);
              ToastFile("Error updating task", "error");
            });
        } catch (locationError) {
          // Show the specific error message to the user on mobile
          console.error("Location error:", locationError.message);

          if (
            locationError.message.includes("unavailable") ||
            locationError.message.includes("blocked") ||
            locationError.message.includes("denied")
          ) {
            alert(
              "📍 GPS is turned off on your device.\n\n" +
                "Android: Settings → Location → Turn ON\n" +
                "iPhone: Settings → Privacy → Location Services → Turn ON\n\n" +
                "Then come back and try again.",
            );
            // GPS is OFF — guide the user
          } else {
            ToastFile(locationError.message, "error");
          }
        }
      } else {
        setIsloading(true);
        await updateTaskLog(state?.taskLog?._id, payload)
          .then(async (res) => {
            setIsloading(false);
            if (res.status === 200) {
              ToastFile("Task updated successfully", "updated");
              reset();

              navigationToBack();
            } else {
              ToastFile("Failed to update task", "error");
            }
          })
          .catch((err) => {
            setIsloading(false);
            console.error("Error updating task:", err);
            ToastFile("Error updating task", "error");
          });
      }
    } else {
      setIsloading(false);
      navigationToBack();
    }
  };

  const {
    register,
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const claimHours = watch("claimHours");
  const payrate = watch("payrate");
  const fuelCost = watch("fuelCost");
  const startTime = watch("startTime");
  const endTime = watch("endTime");
  const actualHours = watch("actualHours");

  useEffect(() => {
    const hours = parseFloat(claimHours) || 0;
    const rate = parseFloat(payrate) || 0;
    const fuel = parseFloat(fuelCost) || 0;

    const total = hours * rate + fuel;
    setValue("totalCost", total.toFixed(2));
  }, [claimHours, payrate, fuelCost, setValue]);

  useEffect(() => {
  if (!startTime || !endTime) return;

  const [startH, startM] = startTime.split(":").map(Number);
  const [endH, endM] = endTime.split(":").map(Number);

  const totalMinutes = (endH * 60 + endM) - (startH * 60 + startM);
  if (totalMinutes <= 0) return;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  setValue("actualHours", `${hours}:${minutes}`);
}, [startTime, endTime, setValue]);


  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
            {isActionEdit
              ? state?.from === "taskhistory"
                ? "Update Task"
                : "Finish Task"
              : "Task Details"}
          </span>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label>Task Category</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              {...register("category", { required: false })}
              isInvalid={errors.category}
            />
          </Form.Group>
          {/* <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              {...register("description", { required: false })}
              isInvalid={errors.description}
            />
            </Form.Group>
            <Form.Group className="mb-3">
            <Form.Label>Work Type</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              {...register("workType", { required: false })}
              isInvalid={errors.workType}
            />
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              disabled={true}
              {...register("date", { required: false })}
              isInvalid={errors.date}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Start Time</Form.Label>
            <Form.Control
              type="time"
              disabled={true}
              //disabled={!isActionEdit}
              {...register("startTime", { required: false })}
              isInvalid={errors.startTime}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>End Time</Form.Label>
            <Form.Control
              type="time"
              disabled={true}
             // disabled={!isActionEdit}
              {...register("endTime", { required: false })}
              isInvalid={errors.endTime}
            />
          </Form.Group>
           <Form.Group className="mb-3">
            <Form.Label>Actual working hours</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              value={formatHours(actualHours)}
              {...register("actualHours", { required: true })}
              isInvalid={errors.actualHours}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {isFixedPay ? "Number of Run" : "Claim Hours / No of Parcels"}
            </Form.Label>
            <Form.Control
              type="text"
              disabled={!isActionEdit}
              {...register("claimHours", { required: true })}
              isInvalid={errors.claimHours}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {isFixedPay ? "Fix Pay Rate" : "Pay Rate / Per Parcel Cost"}
            </Form.Label>
            <Form.Control
              type="text"
              {...register("payrate", { required: true })}
              isInvalid={errors.payrate}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Fuel Cost ($)</Form.Label>
            <Form.Control
              type="text"
              disabled={!isActionEdit}
              {...register("fuelCost", { required: false })}
              isInvalid={errors.fuelCost}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Total Cost ($)</Form.Label>
            <Form.Control
              type="text"
              disabled={true}
              {...register("totalCost", { required: false })}
              isInvalid={errors.totalCost}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Comment (optional)</Form.Label>
            <Form.Control
              as="textarea"
              disabled={!isActionEdit}
              rows={3}
              {...register("comment", { required: false })}
              isInvalid={errors.comment}
            />
          </Form.Group>
          <Button variant="primary" type="submit" style={{ minWidth: "98px" }}>
            {isLoading ? (
              <ButtonLoader width="20px" height="20px" />
            ) : isActionEdit ? (
              "Complete"
            ) : (
              "Done"
            )}
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => navigationToBack()}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </Layout>
  );
};

export default UpdateMyTask;
